var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCannotexist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C7.18669 0 8.34673 0.351894 9.33342 1.01118C10.3201 1.67047 11.0892 2.60754 11.5433 3.7039C11.9974 4.80026 12.1162 6.00666 11.8847 7.17054C11.6532 8.33443 11.0818 9.40353 10.2426 10.2426C9.40353 11.0818 8.33443 11.6532 7.17054 11.8847C6.00666 12.1162 4.80026 11.9974 3.7039 11.5433C2.60754 11.0892 1.67047 10.3201 1.01118 9.33342C0.351894 8.34673 0 7.18669 0 6C0 4.4087 0.632141 2.88258 1.75736 1.75736C2.88258 0.632141 4.4087 0 6 0ZM9.953 2.605L2.605 9.953C3.60172 10.8081 4.88454 11.2553 6.19683 11.2052C7.50911 11.155 8.75409 10.6113 9.68269 9.68269C10.6113 8.75409 11.155 7.50911 11.2052 6.19683C11.2553 4.88454 10.8081 3.60172 9.953 2.605ZM6 0.789C5.0032 0.78922 4.02738 1.07533 3.18828 1.6134C2.34918 2.15146 1.682 2.91891 1.2659 3.8247C0.84979 4.73049 0.702208 5.73663 0.840655 6.72377C0.979103 7.7109 1.39777 8.63762 2.047 9.394L9.395 2.046C8.45089 1.2331 7.24586 0.786934 6 0.789Z",
    fill: "#E32B35"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCannotexist);
export default __webpack_public_path__ + "static/media/Cannotexist.9ce80fcd9392f785f28235d1e3e82eaa.svg";
export { ForwardRef as ReactComponent };